<template>
    <top-bar>
        <slot/>
    </top-bar>
</template>

<script>
    import TopBar from "../components/navigation/TopBar";
    import TopBarGroup from "../components/navigation/TopBarGroup";
    import TopBarItem from "../components/navigation/TopBarItem";

    export default {
        name: "TopBarView",
        components: {TopBarItem, TopBarGroup, TopBar},
        data: function () {
            return {}
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    .fa-icon {
        margin-right: 8px;
    }
</style>